module.exports = {
  "catalog": {
    "flexDirection": "row",
    "alignItems": "center"
  },
  "catalog-margin": {
    "marginBottom": "16"
  },
  "simple-mode": {
    "height": "104",
    "paddingLeft": "32"
  },
  "left-icon": {
    "width": "120",
    "height": "120"
  },
  "text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "28",
    "lineHeight": "30",
    "color": "#8E969B",
    "letterSpacing": 0,
    "textAlign": "center"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-f0650c94!./~/weex-vue-loader/lib/selector.js?type=styles&index=1!./packages/dof-catalog/index.vue
// module id = 559
// module chunks = 0 1